module.exports = __webpack_public_path__ + "img/ba195b5.svg";